import Singleton from './Singleton';

/**
 * 对象控制器类的基类
 */
export default class Controller extends Singleton {
    /**
     * 构造函数
     * @param  {object} options 可选项
     * @return {undefined}
     */
    constructor(options) {
        super(options);
    }

    /**
     * 将此实例对象添加到其他对象中
     * @param {object} obj 添加到的对象
     */
    addTo(obj) {
        obj[this.constructor.name] = this;
    }

    /**
     * 清空
     * @returns {undefined}
     */
    clear() {
    }

    /**
     * 销毁单例
     * @returns {undefined}
     */
    destroy() {
        this.clear();
        super.destroy();
    }
}
